import { useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

import {
  Button,
  InputBase,
  InputAdornment,
  Typography,
  Link,
} from "@mui/material";

import { apiContext, apiDict } from "../../context/api-v1/api";
import UserAdminLayout from "../../components/userAdminLayout";
import Toast from "../../components/Toast";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PasswordIcon from "@mui/icons-material/Password";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import IconButton from "@mui/material/IconButton";
import { useTitle } from "../../utils/hooks";

export default function UserRegister() {
  useTitle("用户注册");
  return <UserRegisterLayout />;
}
function UserRegisterLayout() {
  const loginFromRef = useRef({ usr: "", psd1: "", psd2: "" });
  const [statusCode, setStatusCode] = useState();
  const [psdShow, setPsdShow] = useState(false);

  const [msgBoxShow, setMsgBoxShow] = useState(false);
  const [msgTips, setMsgTips] = useState({});

  const navigate = useNavigate();

  function handleInputUsr(e) {
    loginFromRef.current.usr = e.target.value;
  }
  function handleInputPsd1(e) {
    loginFromRef.current.psd1 = e.target.value;
  }
  function handleInputPsd2(e) {
    loginFromRef.current.psd2 = e.target.value;
  }
  function handleSubmit() {
    const usr = loginFromRef.current.usr;
    const psd1 = loginFromRef.current.psd1;
    const psd2 = loginFromRef.current.psd2;

    if (!usr || !psd1 || !psd2) {
      setMsgBoxShow(true);
      setMsgTips({ status: "warning", msg: "请填写所有注册字段" });
    } else if (psd1 !== psd2) {
      setMsgBoxShow(true);
      setMsgTips({ status: "error", msg: "密码输入不一致" });
    } else if (psd1.length < 6 || /^\d*$/.test(psd1)) {
      setMsgBoxShow(true);
      setMsgTips({ status: "info", msg: "密码长度需要大于6, 且不能均为数字" });
    } else if (usr.length < 3) {
      setMsgBoxShow(true);
      setMsgTips({ status: "info", msg: "用户名需大于2位字符" });
    } else {
      const usrDatas = {
        username: usr,
        password: psd1,
      };
      apiContext(apiDict.signup, "POST", "", setStatusCode, usrDatas);
    }
  }

  function handleMsgBoxClose() {
    setMsgBoxShow(false);
  }

  useEffect(() => {
    if (!statusCode) {
      return;
    }
    if (statusCode !== 201) {
      setMsgBoxShow(true);
      setMsgTips({ status: "error", msg: "注册错误, 请重新注册" });
    } else {
      setMsgBoxShow(true);
      setMsgTips({ status: "success", msg: "注册成功, 跳转登录页" });
      setTimeout(() => {
        navigate("/user/login");
      }, 1500);
    }
  }, [statusCode]);

  return (
    <>
      <UserAdminLayout>
        <IconButton
          sx={{
            position: "absolute",
            left: "1.5vw",
            top: "2vh",
          }}
          onClick={() => navigate("/")}
        >
          <HomeOutlinedIcon sx={{ fontSize: "1.5rem !important" }} />
        </IconButton>
        <Typography variant="h6" sx={{ mb: "20px", fontWeight: "600" }}>
          用户注册
        </Typography>
        <InputBase
          sx={{
            backgroundColor: "#babec2",
            borderRadius: "6px",
            width: "15vw",
            minWidth: "180px",
            height: "5vh",
            fontSize: "13px",
            mt: "20px",

            ".MuiInputBase-input": {
              textAlign: "center",
              display: " flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "34px",
            },
          }}
          color="third"
          placeholder="username"
          required
          startAdornment={
            <InputAdornment position="start" sx={{ ml: "10px" }}>
              <PersonAddIcon />
            </InputAdornment>
          }
          onChange={handleInputUsr}
        />
        <InputBase
          sx={{
            backgroundColor: "#babec2",
            borderRadius: "6px",
            width: "15vw",
            minWidth: "180px",
            height: "5vh",
            fontSize: "13px",
            mt: "20px",

            ".MuiInputBase-input": {
              textAlign: "center",
              display: " flex",
              justifyContent: "center",
              alignItems: "center",
              // marginRight: "35px",
            },
          }}
          color="third"
          placeholder="password"
          required
          type={psdShow ? "text" : "password"}
          startAdornment={
            <InputAdornment position="start" sx={{ ml: "10px" }}>
              <PasswordIcon fontSize="small" />
            </InputAdornment>
          }
          endAdornment={
            <InputAdornment
              position="end"
              sx={{ mr: "10px", cursor: "pointer" }}
              onClick={() => setPsdShow(!psdShow)}
            >
              {psdShow ? (
                <VisibilityIcon sx={{ fontSize: "13px" }} />
              ) : (
                <VisibilityOffIcon sx={{ fontSize: "13px" }} />
              )}
            </InputAdornment>
          }
          d
          onChange={handleInputPsd1}
        />
        <InputBase
          sx={{
            backgroundColor: "#babec2",
            borderRadius: "6px",
            width: "15vw",
            minWidth: "180px",
            height: "5vh",
            fontSize: "13px",
            mt: "20px",

            ".MuiInputBase-input": {
              textAlign: "center",
              display: " flex",
              justifyContent: "center",
              alignItems: "center",
              // marginRight: "35px",
            },
          }}
          color="third"
          placeholder="repassword"
          required
          type={psdShow ? "text" : "password"}
          startAdornment={
            <InputAdornment position="start" sx={{ ml: "10px" }}>
              <PasswordIcon fontSize="small" />
            </InputAdornment>
          }
          endAdornment={
            <InputAdornment
              position="end"
              sx={{ mr: "10px", cursor: "pointer" }}
              onClick={() => setPsdShow(!psdShow)}
            >
              {psdShow ? (
                <VisibilityIcon sx={{ fontSize: "13px" }} />
              ) : (
                <VisibilityOffIcon sx={{ fontSize: "13px" }} />
              )}
            </InputAdornment>
          }
          d
          onChange={handleInputPsd2}
        />
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{ mt: "30px", width: "10vw" }}
          color="fivth"
          disabled  // 2025-09-10 13:54:47 本人使用, 暂不开放注册
        >
          注册
        </Button>
        <Link
          onClick={() => navigate("/user/login")}
          sx={{
            color: "#6c5f57",
            fontSize: "10px",
            cursor: "pointer",
            mt: "15px",
          }}
        >
          Already have account ?
        </Link>
        <Toast
          open={msgBoxShow}
          onClose={handleMsgBoxClose}
          severity={msgTips.status}
          message={msgTips.msg}
        />
      </UserAdminLayout>
    </>
  );
}
